
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, ExternalLink } from "lucide-react";

export const FormExpired = () => (
  <div className="min-h-screen flex items-center justify-center bg-white dark:bg-gray-900 p-4">
    <Card className="bg-white dark:bg-gray-800 shadow-lg border border-gray-300 dark:border-gray-700 w-full max-w-lg p-8">
      <div className="text-center space-y-6">
        <div className="flex justify-center">
          <AlertTriangle size={48} className="text-amber-500" />
        </div>
        
        <div className="h-20 w-24 mx-auto">
          <img 
            src="/lovable-uploads/57a7aaa6-bf38-4409-a65a-b5c45e8026c6.png" 
            alt="Mantle Logo" 
            className="h-full w-full object-contain"
          />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          Form Error
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          There was an error loading this form. The link may have expired or is invalid. 
          Please return to the main onboarding form.
        </p>
        <Button 
          className="mt-2 bg-blue-600 hover:bg-blue-700 text-white flex items-center mx-auto"
          onClick={() => window.location.href = '/onboarding'}
        >
          <ExternalLink className="mr-2 h-4 w-4" />
          Go to onboarding form
        </Button>
      </div>
    </Card>
  </div>
);
